import * as React from 'react'
import { Accordion, Button, Card, Image } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import { copyObject } from '../../../../utils'
import Worker from './Worker'
import { CompanyT } from '../../../../types/Company'
import * as _ from 'lodash'
import { JobWorkerObj, JobWorkerT } from '../../../../types/JobWorker'
import { getJobDuration } from '../JobUtils'
import { isEmpty } from '../../../../utils/validator'
import CrewProspects from './CrewProspects'
import { JobT } from '../../../../types/Job'
import { currentUserIsClient, currentUserIsManager } from '../../../../utils/currentUser'
import { getInitialsLastName } from '../../../../utils/utilsT'
import { IAppState } from '../../../../redux/reducers'
import { SeeByT } from '../../../../types/SeeByT'
import { JobMode } from '../Job'
import { getSeeByItems } from '../../../../api/SeeByApi'
import { CrewMember } from '../../WorkersTab/WorkersTab'
import images from '../../../../constants/images'
import LineItemSeeBy from '../../../../components/LineItemSeeBy'

const style = {
    textDisplayName: {
        flex: 1, justifyContent: "center", alignSelf: 'center', margin: 2, padding: 5
    }
}

interface CrewTabProps {
    company: CompanyT
    job: JobT
    // crew: Array<WorkerT> // TODO: Convert from `any` to CrewT
    updateJob(key: string, value: any): void
    tabIsActive: boolean
    jobMode: JobMode
}

const CrewTab: React.FunctionComponent<CrewTabProps> = (props): JSX.Element => {
    let [activeKey, setActiveKey] = React.useState(0)
    const [activeKeyNoShow, setActiveKeyNoShow] = React.useState(0)
    const [dirtyCrew, setDirtyCrew] = React.useState([JobWorkerObj, JobWorkerObj])
    let auth = useSelector((state: IAppState) => state.auth)
    // let roles = auth.userData.roles
    const isClient = currentUserIsClient()
    const isManager = currentUserIsManager()
    const jobDuration = React.useMemo(() => getJobDuration(props.job), [props.job])
    const [workersNoShows, setWorkersNoShows] = React.useState([]);
    const [seeByItems, setSeeByItems] = React.useState<Array<SeeByT>>([]);
    const [isReady, setIsReady] = React.useState(false);
    React.useEffect((): void => {
        if (!_.isEqual(props.job.crew, dirtyCrew)) {
            // addInitCrew()
            // console.log("setDirtyCrew->.crew", job.crew)
            // console.log("setDirtyCrew", dirtyCrew)
            setDirtyCrew(props.job.crew)
            setWorkersNoShows(getWorkersNoShows(props.job.crew))
        }
    }, [props?.job?.crew])


    React.useEffect(() => {
        if (props.jobMode == JobMode.Edit) {
            getSeeByItems(props?.job?.id, {}).then((items) => {
                setSeeByItems(items)
            })
        }
    }, [props?.job?.crew]);



    const parseSeebyWithCrew = (seeByItems: Array<SeeByT>, jobCrew: Array<JobWorkerT>) => {
        if (!_.isArray(jobCrew)) {
            return []
        }
        return seeByItems.filter((item, index) => {
            return jobCrew.find((x) => x.id == item?.user?.id)
        })
    }
    /**
     * 
     */
    const addWorker = (): void => {
        let crewClone = copyObject(dirtyCrew)
        crewClone.push(copyObject(JobWorkerObj))
        setDirtyCrew(crewClone)
        props.updateJob('crew', crewClone)
        onChangeAccordion(crewClone.length - 1)
    }

    /**
     * 
     * @param index 
     */
    const onChangeAccordion = (index: number, type: 'no-show' | 'show' = 'show'): void => {
        if (index < 0) index = 0
        if (type == 'show') {
            if (index != activeKey) setActiveKey(index)
            else setActiveKey(null)
        } else {
            if (index != activeKeyNoShow) setActiveKeyNoShow(index)
            else setActiveKeyNoShow(null)
        }
    }



    /**
     * removeWorker
     * If there's a person already in that card, it should just clear the card.  If there's no person in the card, then it should remove the card
     * @param index 
     */
    const removeWorker = (index: number): void => {
        let crewClone = copyObject(dirtyCrew)
        const cloneWorker = _.isArray(crewClone) && crewClone[index]
        let clear = true
        if (cloneWorker && !cloneWorker.id) {
            clear = false
        }
        const filteredItems = crewClone.slice(0, index).concat(crewClone.slice(index + 1, crewClone.length))
        if (filteredItems.length <= 1 && clear) {
            filteredItems.push(JobWorkerObj)
        }
        setDirtyCrew(filteredItems)
        props.updateJob('crew', filteredItems)
        onChangeAccordion(filteredItems.length - 1)
    }


    const getDisplayName = (worker: JobWorkerT) => {
        if (isManager) {
            return `${worker.firstName} ${worker.lastName}`
        } else {
            return getInitialsLastName(worker.firstName, worker.lastName)
        }
    }

    /**
     * 
     * @param worker JobWorkerT
     * @param index 
     */
    const renderItemWoker = (worker: JobWorkerT, index, type: 'no-show' | 'show' = 'show') => {
        return (
            <Card key={index}>
                <Card.Header>
                    <Accordion.Header as={Button} variant="link" eventKey={`${index}`} onClick={(e) => {
                        onChangeAccordion(index, type)
                    }}>
                        <span>Worker {index + 1} {worker.firstName != '' || worker.lastName != '' ? (<span> - {worker.firstName} {currentUserIsClient ? `${worker.lastName.charAt(0)}.` : `${worker.lastName}`}</span>) : ''}</span>
                    </Accordion.Header>
                    <span style={{ position: "absolute", right: 5 }}>
                        <i className="fa fa-close"
                            onClick={(): void => { removeWorker(index) }}
                            style={{ color: "red", cursor: "pointer" }} />
                    </span>
                </Card.Header>
                <Accordion.Collapse eventKey={`${index}`}>
                    <Card.Body>
                        <Worker
                            key={index}
                            job={props.job}
                            jobDuration={jobDuration}
                            // crew={job.crew}
                            index={index}

                            removeWorker={removeWorker}
                            updateJob={props.updateJob}
                            updateCrew={updateCrew}
                            worker={worker} />
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        )
    }


    /**
    * 
    */
    const renderWorkers = (): Array<JSX.Element> => {
        return dirtyCrew.map((worker: JobWorkerT, index: any) => {
            if (!worker.noShow) {
                return (
                    <div key={index}>
                        {renderItemWoker(worker, index, 'show')}
                    </div>
                )
            }
        })
    }

    /**
     * 
     */
    const renderWorkersNoShow = (): Array<JSX.Element> => {
        return dirtyCrew.map((worker: JobWorkerT, index: any) => {
            if (_.has(worker, "noShow") && worker.noShow == true) {
                return (
                    <div key={index}>
                        {renderItemWoker(worker, index, 'no-show')}
                    </div>
                )
            }

        })
    }

    /**
    * 
    * @returns 
    */
    const getWorkersNoShows = (crew): Array<JobWorkerT> => {
        if (!_.isArray(crew)) {
            return []
        }
        console.log("getWorkersNoShows", crew)
        const items = crew.filter((worker => _.has(worker, "noShow") && worker.noShow == true))
        console.log("getWorkersNoShows", items)
        return items
    }
    /**
     * 
     * @param workerIndex 
     * @param worker 
     */
    const updateCrew = (workerIndex: number, worker: JobWorkerT): void => {
        let crewClone = copyObject(dirtyCrew)
        console.log('crewCloneClone->crewClone', crewClone)
        if (!_.isEqual(crewClone[workerIndex], worker)) {
            crewClone[workerIndex] = worker
            console.log('crewCloneClone', crewClone)
            setDirtyCrew(crewClone)
            props.updateJob('crew', crewClone)
            setWorkersNoShows(getWorkersNoShows(crewClone))
        }
    }
    const renderSeeByItem = (item: SeeByT, index) => {
        return (
            <Card style={{ backgroundColor: "#fff" }}>
                <Card.Body>
                    <div className="d-flex flex-row">
                        <div className="d-flex p-2 flex-fill">
                            <Image roundedCircle
                                style={{ width: 60, height: 60 }}
                                src={item?.user?.profilePic ? `${item?.user?.profilePic}` : images.noProfilePic} />
                            {item?.user &&
                                <span style={style.textDisplayName}>
                                    {item?.user?.firstName} {item?.user?.lastName}
                                </span>}
                        </div>
                    </div>
                </Card.Body>
            </Card>


        )
    }

    if (!props.tabIsActive) {
        return null
    }
    return (
        <div>
            <Accordion defaultActiveKey={'0'} activeKey={`${activeKey}`}>
                {renderWorkers()}
            </Accordion>
            {(isManager) && <Button
                onClick={(): void => { addWorker() }}
                variant='info'>
                Add Worker
            </Button>}
            <CrewProspects job={props.job} />
            {workersNoShows.length > 0 && <div className='mt-2'>
                <h3>No-shows</h3>
                <Accordion defaultActiveKey={'0'} activeKey={`${activeKeyNoShow}`}>
                    {renderWorkersNoShow()}
                </Accordion>
            </div>}
            {seeByItems.length > 0 && <div className='mt-2 p-1'>
                <h3>Seen By</h3>
                <div className="d-flex flex-row flex-wrap">
                    {seeByItems.map((item, index) => {
                        return (
                            <LineItemSeeBy key={index} item={item} index={index} />
                        )
                    })}
                </div>
            </div>}
        </div>
    )
}

export default CrewTab